import { Box, Typography } from "@mui/material"
import HeaderWithBar from "./HeaderWithBar";

const OurProducts = () => {
    const currentProducts = [
        { icon: "clarity:fuel-line", label: "1G Ethanol" },
        { icon: "qlementine-icons:test-16", label: "Extra neutral alcohol" },
        { icon: "mynaui:leaf", label: "Fermented organic manure" },
        { icon: "arcticons:emoji-bubbles", label: "Liquid CO2" }
    ];

    const proposedProducts = [
        { icon: "clarity:fuel-line", needStroke: false, label: "2G Ethanol" },
        { icon: "mdi:gas-tank-outline", needStroke: false, label: "Compressed biogas" },
        { icon: "bi:airplane", needStroke: false, label: "Sustainable aviation fuel" },
        { icon: "iconoir:hydrogen", needStroke: false, label: "Green Hydrogen" },
        { icon: "lets-icons:chemistry-light", needStroke: false, label: "Isolate rice protein" },
        { icon: "arcticons:crystal-para-samsung-internet", needStroke: true, label: "Silica" }
    ];

    return (
        <Box sx={{ py: { xs: 5, md: 12 }, px: { xs: 4, md: 20 }, gap: '20px' }}>
            <HeaderWithBar text="Our Products" />
            <Typography variant="h3" gutterBottom sx={{ lineHeight: "60px" }}>
                Current Products
            </Typography>
            <Box display="grid" gridTemplateColumns={{ xs: 'repeat(2, 1fr)', md: 'repeat(auto-fit, minmax(150px, 1fr))' }} gap={2} mb={4} textAlign="center">
                {currentProducts.map((product, index) => (
                    <Box key={index} display="flex" flexDirection="column" alignItems="center" justifyContent="start" m={2}>
                        <iconify-icon icon={product.icon} width="60" height="60" style={{ color: "#6D9A5B", strokeWidth: 2, padding: 3, marginBottom: "8px" }}></iconify-icon>
                        <Typography variant="subtitle1">{product.label}</Typography>
                    </Box>
                ))}
            </Box>
            <Typography variant="h3" gutterBottom sx={{ lineHeight: "60px" }}>
                Proposed Products
            </Typography>
            <Box display="grid" gridTemplateColumns={{ xs: 'repeat(2, 1fr)', md: 'repeat(auto-fit, minmax(150px, 1fr))' }} gap={2} textAlign="center">
                {proposedProducts.map((product, index) => (
                    <Box key={index} display="flex" flexDirection="column" alignItems="center" justifyContent="start" m={2}>
                        <iconify-icon icon={product.icon} width="60" height="60" style={{ color: "#F2A77B", strokeWidth: product.needStroke && 2, padding: 3, marginBottom: "8px" }}></iconify-icon>
                        <Typography variant="subtitle1">{product.label}</Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}

export default OurProducts;